import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Campaigns from './pages/Campaigns';
import CampaignDetail from './pages/CampaignDetail';
import CreateCampaign from './pages/CreateCampaign';
import FacebookAccounts from './pages/FacebookAccounts';
import AISettings from './pages/AISettings';
import Upload from './pages/Upload';
import Profile from './pages/Profile';

// 受保护的路由组件
function ProtectedRoute({ children }) {
	const { isAuthenticated } = useAuthStore();
	
	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}
	
	return children;
}

// 公共路由组件（已登录用户重定向到仪表板）
function PublicRoute({ children }) {
	const { isAuthenticated } = useAuthStore();
	
	if (isAuthenticated) {
		return <Navigate to="/dashboard" replace />;
	}
	
	return children;
}

function App() {
	return (
		<div className="min-h-screen bg-gray-50">
			<Routes>
				{/* 公共路由 */}
				<Route
					path="/login"
					element={
						<PublicRoute>
							<Login />
						</PublicRoute>
					}
				/>
				<Route
					path="/register"
					element={
						<PublicRoute>
							<Register />
						</PublicRoute>
					}
				/>
				
				{/* 受保护的路由 */}
				<Route
					path="/"
					element={
						<ProtectedRoute>
							<Layout />
						</ProtectedRoute>
					}
				>
					<Route index element={<Navigate to="/dashboard" replace />} />
					<Route path="dashboard" element={<Dashboard />} />
					<Route path="campaigns" element={<Campaigns />} />
					<Route path="campaigns/create" element={<CreateCampaign />} />
					<Route path="campaigns/:id" element={<CampaignDetail />} />
					<Route path="facebook-accounts" element={<FacebookAccounts />} />
					<Route path="ai-settings" element={<AISettings />} />
					<Route path="upload" element={<Upload />} />
					<Route path="profile" element={<Profile />} />
				</Route>
				
				{/* 404 页面 */}
				<Route path="*" element={<Navigate to="/dashboard" replace />} />
			</Routes>
		</div>
	);
}

export default App;
